import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function MethodologyPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-6 pb-12">
        <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
          <nav className="text-sm text-stone-500 mb-6">
            <a href="/" className="hover:text-emerald-700 transition-colors">{t('breadcrumb_home')}</a>
            <span className="mx-2">/</span>
            <span className="text-stone-700">Methodology</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6">Methodology</h1>

          <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-8">
            This page explains how we research and structure the information on CSSBuyBR. We believe a clear methodology helps readers understand where our content comes from and how to use it responsibly.
          </p>

          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">How We Gather Information</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                Our guides are built from a combination of publicly available information, general knowledge of the buying-agent and e-commerce process, and practical buyer considerations. We organize this information into clear categories and step-by-step guides so it is easier to understand and act on.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">What We Evaluate</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                When creating guides, we focus on the factors that matter most to buyers. These include product details, price, weight and shipping, quality control (QC) photos, storage and consolidation, coupons and discounts, and safety considerations. Each factor is explained so readers know what to check before committing to a purchase.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Product Categories</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                Our product categories mirror the common sections found in buying-agent spreadsheets, such as shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, and perfumes. We group related items together to make browsing and comparison simpler.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">How We Keep Content Current</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We periodically review our guides and update them to reflect changes in platforms, policies, and common buyer questions. Each article includes a last-updated date. Because the e-commerce landscape changes quickly, we always recommend verifying the latest information directly before making a purchase.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Limitations</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                This website is an independent informational resource and does not officially represent CSSBuy or any other platform. We cannot guarantee the accuracy, completeness, or timeliness of every detail, and product prices, availability, and policies can change without notice. Always confirm current information directly with the relevant seller or platform.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}